export class People {
	public name: string;
	public email: string;
	public photo: string;

	constructor(name: string, email: string, photo: string) {
		this.name = name;
		this.email = email;
		this.photo = photo;
	}
}
